<p-dialog
    [(visible)]="visible"
    [header]="'service.settings.specialistRecord.contactType.label' | translate"
>
    <div class="flex gap-large pt-5">
        <app-check-input [form]="form" id="active"
            label="service.settings.specialistRecord.contactType.fields.active"
        ></app-check-input>
        <app-text-input [form]="form" id="name"
            label="service.settings.specialistRecord.contactType.fields.name"
        ></app-text-input>
        <app-text-input [form]="form" id="description"
            label="service.settings.specialistRecord.contactType.fields.description"
        ></app-text-input>
    </div>

    <ng-template #footer>
        <app-action-buttons (primaryClickEvent)="submit()" (secondaryClickEvent)="show(false)"></app-action-buttons>
    </ng-template>
</p-dialog>
